var React = require('react');

function WordHelper (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none"},[React.createElement("path",{"d":"M24 3v24l-1 1H4c-3 0-3-3-3-3V2l1-1h18l1 1h2l1 1z","stroke":"#2F73A7","strokeLinejoin":"round","key":0}),React.createElement("text",{"fontFamily":"WorkSans-Regular, Work Sans","fontSize":"20","fill":"#0D3B5E","x":"6","y":"20","key":1},"?"),React.createElement("path",{"stroke":"#2F73A7","strokeLinecap":"round","strokeLinejoin":"round","d":"M4 25h17V2","key":2})]));
}

WordHelper.defaultProps = {"width":"25","height":"29"};

module.exports = WordHelper;

WordHelper.default = WordHelper;
